import { useEffect, useState } from 'react'

import { Button, CheckBox, Form, Grid, Input, Picker, Row, Span } from 'components'
import { isEmptyOrBefore } from 'components/DatePicker/utils'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { SPACING } from 'utils'
import { IPendingCreSearchForm } from '../../PendingCreSearch'
import { UseFormWatch } from 'react-hook-form'

interface IFilterPendingCre {
  control: any
  handleSubmit: any
  errors: any
  onChange: any
  handleSearchPendingCre: (_isClick?: boolean, form?: IPendingCreSearchForm) => void
  handleClearButton: () => void
  dateErrors?: any
  watch: UseFormWatch<IPendingCreSearchForm>
}
export const FilterPendingCre = ({
  dateErrors,
  watch,
  control,
  handleSubmit,
  errors,
  handleSearchPendingCre,
  handleClearButton
}: IFilterPendingCre) => {
  const [blockButton, setBlockButton] = useState<boolean>(false)
  // Controle de checkbox caso desmarcado e não tiver nenhum outro,
  // aplicando checkBox padrão "Todos"
  // useEffect(() => {
  //   if (!form.FlSubContrato && !form.FlCreBloqueado && !form.FlTodos) {
  //     onChange({
  //       target: { name: 'FlTodos', value: true }
  //     })
  //   }
  // }, [form.FlBacklog])

  // useEffect(() => {
  //   if (!form.FlBacklog && !form.FlSubContrato && !form.FlTodos) {
  //     onChange({
  //       target: { name: 'FlTodos', value: true }
  //     })
  //   }
  // }, [form.FlCreBloqueado])

  // useEffect(() => {
  //   if (!form.FlBacklog && !form.FlCreBloqueado && !form.FlTodos) {
  //     onChange({
  //       target: { name: 'FlTodos', value: true }
  //     })
  //   }
  // }, [form.FlSubContrato])
  // /////////////////////

  // ///// Controle da comutação entre checkbox Todos e os demais
  // useEffect(() => {
  //   if (form.FlBacklog || form.FlCreBloqueado || form.FlSubContrato) {
  //     onChange({
  //       target: { name: 'FlTodos', value: false }
  //     })
  //   }
  // }, [form.FlBacklog, form.FlCreBloqueado, form.FlSubContrato])

  // useEffect(() => {
  //   if (form.FlTodos) {
  //     onChange({
  //       target: { name: 'FlBacklog', value: false }
  //     })
  //     onChange({
  //       target: { name: 'FlCreBloqueado', value: false }
  //     })
  //     onChange({
  //       target: { name: 'FlSubContrato', value: false }
  //     })
  //   } else if (!form.FlBacklog && !form.FlCreBloqueado && !form.FlSubContrato) {
  //     onChange({
  //       target: { name: 'FlTodos', value: true }
  //     })
  //   }
  // }, [form.FlTodos])

  useEffect(() => {
    BlockButton()
  }, [dateErrors])

  // useEffect(() => {
  //   setDateErrors(null)
  //   if (form.DtAnaliseFim && !form.DtAnaliseInicio) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnaliseInicio: { message: 'Digite a data inicial' }
  //     })
  //   }

  //   if (form.DtAnaliseInicio && !form.DtAnaliseFim) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnaliseFim: { message: 'Digite a data final' }
  //     })
  //   }

  //   if (form.DtPeriodoFim && !form.DtPeriodoInicio) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtPeriodoInicio: { message: 'Digite a data inicial' }
  //     })
  //   }

  //   if (form.DtPeriodoInicio && !form.DtPeriodoFim) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtPeriodoFim: { message: 'Digite data final' }
  //     })
  //   }

  //   if (form.CompetenciaFim && !form.CompetenciaInicio) {
  //     setDateErrors({
  //       ...dateErrors,
  //       CompetenciaInicio: { message: 'Digite a competencia Inicial' }
  //     })
  //   }

  //   if (form.CompetenciaInicio && !form.CompetenciaFim) {
  //     setDateErrors({
  //       ...dateErrors,
  //       CompetenciaFim: { message: 'Digite a competencia Final' }
  //     })
  //   }

  //   if (form.DtAnexoFim && !form.DtAnexoInicio) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnexoInicio: { message: 'Digite a data inicial' }
  //     })
  //   }

  //   if (form.DtAnexoInicio && !form.DtAnexoFim) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnexoFim: { message: 'Digite a data final' }
  //     })
  //   }

  //   // Vericação datas de Competencia
  //   if (
  //     (form.CompetenciaFim && form.CompetenciaInicio) &&
  //     (new Date(moment(form.CompetenciaFim).toISOString()) <=
  //       new Date(moment(form.CompetenciaInicio).add(-1, 'month').toISOString()))) {
  //     setDateErrors({
  //       ...dateErrors,
  //       CompetenciaFim: { message: 'Data Competencia final menor que a inicial.' }
  //     })
  //   }

  //   // Vericação datas de Anexo
  //   if (
  //     (form.DtAnexoFim && form.DtAnexoInicio) &&
  //     (new Date(moment(form.DtAnexoFim).toISOString()) <=
  //       new Date(moment(form.DtAnexoInicio).add(-1, 'day').toISOString()))) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnexoFim: { message: 'Data Anexo final menor que a inicial.' }
  //     })
  //   }

  //   // Vericação datas de Período
  //   if (
  //     (form.DtPeriodoFim && form.DtPeriodoInicio) &&
  //     (new Date(moment(form.DtPeriodoFim).toISOString()) <=
  //       new Date(moment(form.DtPeriodoInicio).add(-1, 'day').toISOString()))) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtPeriodoFim: { message: 'Data Pendencia final menor que a inicial.' }
  //     })
  //   }

  //   // Vericação datas de Análise
  //   if (
  //     (form.DtAnaliseFim && form.DtAnaliseInicio) &&
  //     (new Date(moment(form.DtAnaliseFim).toISOString()) <=
  //       new Date(moment(form.DtAnaliseInicio).add(-1, 'day').toISOString()))) {
  //     setDateErrors({
  //       ...dateErrors,
  //       DtAnaliseFim: { message: 'Data Análise final menor que a inicial.' }
  //     })
  //   }
  // }, [
  //   form.DtAnaliseFim,
  //   form.DtAnaliseInicio,
  //   form.DtAnexoFim,
  //   form.DtAnexoInicio,
  //   form.DtPeriodoFim,
  //   form.DtPeriodoInicio,
  //   form.CompetenciaFim,
  //   form.CompetenciaInicio
  // ])

  const BlockButton = () => {
    let hasBlock = false

    if (dateErrors)
      for (const [, value] of Object.entries(dateErrors)) {
        if (String(Object.values(value)[0]).trim().length > 0) hasBlock = true
      }

    if (hasBlock) setBlockButton(true)
    else setBlockButton(false)
  }

  function handleSubmitForm(form: IPendingCreSearchForm) {
    handleSearchPendingCre(true, form)
  }

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid
        gridCols="1fr 2fr 1fr 0.1fr 0.9fr 0.9fr 2fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          label="Contrato"
          placeholder="Nº"
          formValue="CdContrato"
          control={control}
          // value={form.CdContrato}
          // onChange={onChange}
          maxLength={100}
        />
        <Input
          label="Fornecedor"
          control={control}
          placeholder="Nome do Fornecedor"
          formValue="NmFornecedor"
          // value={form.NmFornecedor}
          // onChange={onChange}
          maxLength={100}
        />
        <Picker
          label="Competência"
          control={control}
          // value={form.CompetenciaInicio || null}
          // maxDate={form.CompetenciaFim || null}
          formValue='CompetenciaInicio'
          placeholder="mm/aaaa"
          views={['month', 'year']}
          inputFormat="MM/yyyy"
          // onChange={(date) =>
          //   onChange({ target: { name: 'CompetenciaInicio', value: date } })
          // }
          errors={errors}
          type={'monthAndYear'}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          marginLeft="-10px"
          control={control}
          errors={errors}
          formValue='CompetenciaFim'
          // value={form.CompetenciaFim || null}
          // minDate={form.CompetenciaInicio || null}
          placeholder="mm/aaaa"
          views={['month', 'year']}
          inputFormat="MM/yyyy"
          // onChange={(date) =>
          //   // onChange({ target: { name: 'CompetenciaFim', value: date } })
          // }
          type={'monthAndYear'}
        />
        <Input
          label="Nº CRE"
          placeholder="Nº"
          formValue="CdCRE"
          // value={form.CdCRE}
          control={control}
          // // onChange={onChange}
          maxLength={100}
        />
        <Input
          label="Analista"
          placeholder="Nome do Analista"
          formValue="NmAnalista"
          control={control}
          // value={form.NmAnalista}
          // // onChange={onChange}
          maxLength={100}
        />
      </Grid>
      <Grid
        gridCols="1fr 0.1fr 0.9fr 0.9fr 1fr 0.1fr 0.9fr 0.9fr 0.9fr 0.1fr 0.9fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing15} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          label="Data Análise"
          // value={form.DtAnaliseInicio || null}
          control={control}
          placeholder="dd/mm/aaaa"
          formValue='DtAnaliseInicio'
          // onChange={(date) =>
          // onChange({ target: { name: 'DtAnaliseInicio', value: date } })
          // }
          errors={errors}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          marginLeft="-10px"
          control={control}
          errors={errors}
          formValue='DtAnaliseFim'
          // minDate={form.DtAnaliseInicio || null}
          placeholder="dd/mm/aaaa"
        // onChange={(date) =>
        // onChange({ target: { name: 'DtAnaliseFim', value: date } })
        // }
        />
        <div />
        <Picker
          label="Data Anexo"
          formValue='DtAnexoInicio'
          // value={form.DtAnexoInicio || null}
          // maxDate={form.DtAnexoFim || null}
          control={control}
          placeholder="dd/mm/aaaa"
          // onChange={(date) =>
          // onChange({ target: { name: 'DtAnexoInicio', value: date } })
          // }
          errors={errors} />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          marginLeft="-10px"
          formValue='DtAnexoFim'
          // value={form.DtAnexoFim || null}
          // minDate={form.DtAnexoInicio || null}
          control={control}
          errors={errors}
          placeholder="dd/mm/aaaa"
        // onChange={(date) =>
        // onChange({ target: { name: 'DtAnexoFim', value: date } })
        // }
        />
        <div />
        <Picker
          formValue='DtPeriodoInicio'
          label="Período Pendência"
          // value={form.DtPeriodoInicio || null}
          // maxDate={form.DtPeriodoFim || null}
          control={control}
          placeholder="dd/mm/aaaa"
          // onChange={(date) =>
          // onChange({ target: { name: 'DtPeriodoInicio', value: date } })
          // }
          errors={errors}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          formValue='DtPeriodoFim'
          marginLeft="-10px"
          // value={form.DtPeriodoFim || null}
          // minDate={form.DtPeriodoInicio || null}
          control={control}
          errors={errors}
          placeholder="dd/mm/aaaa"
        // onChange={(date) =>
        // onChange({ target: { name: 'DtPeriodoFim', value: date } })
        // }
        />
      </Grid>
      <Grid
        gridCols="6fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing15} 0 ${SPACING.spacing10} 0`}
      >
        <Row gap="1.5rem" marginTop={SPACING.spacing15}>
          <CheckBox
            // onChange={(e) =>
            // onChange({
            // target: {name: 'FlBacklog', value: e.target.checked }
            //   })
            // }
            formValue='FlBacklog'
            label="Backlog"
            checked={watch('FlBacklog')}
            // onClick={null}
            control={control}
          // checked={form.FlBacklog}
          />
          <CheckBox
            // onChange={(e) =>
            // onChange({
            // target: {name: 'FlCreBloqueado', value: e.target.checked }
            //   })
            // }
            formValue='FlCreBloqueado'
            label="Bloqueio"
            checked={watch('FlCreBloqueado')}
            // onClick={null}
            control={control}
          // checked={form.FlCreBloqueado}
          />
          <CheckBox
            // onChange={(e) =>
            // onChange({
            // target: {name: 'FlSubContrato', value: e.target.checked }
            //   })
            // }
            formValue='FlSubContrato'
            checked={watch('FlSubContrato')}
            control={control}
            label="Subcontrato"
          // onClick={null}
          // checked={form.FlSubContrato}
          />
          <CheckBox
            // onChange={(e) =>
            // onChange({
            // target: {name: 'FlTodos', value: e.target.checked }
            //   })
            // }
            formValue='FlTodos'
            control={control}
            checked={watch('FlTodos')}
            label="Todos"
          // onClick={null}
          // checked={form.FlTodos}
          />
        </Row>
        <Row justifyContent="flex-end" marginTop={SPACING.spacing5}>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={handleClearButton}
          />
          <Button
            text="Pesquisar"
            endIcon={<MagnifyingGlassIcon />}
            marginLeft={SPACING.spacing20}
            type={'submit'}
            disabled={blockButton}
          />
        </Row>
      </Grid>
    </Form>
  )
}
